module.exports = __webpack_public_path__ + "static/media/home_health_news.1ac21a54.png";